module.exports = __webpack_public_path__ + "static/img/k_2@2x (1).17c7226.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/k_2@2x (1).png
// module id = fZao
// module chunks = 2